module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rotator-container"
  }, [_c('div', {
    staticClass: "return-to-controls",
    on: {
      "click": _vm.returnToControls
    }
  }, [_c('div', {
    staticClass: "top-bar bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar bar"
  })]), _vm._v(" "), _c('Breadcrumbs', {
    attrs: {
      "breadcrumbList": _vm.breadcrumbList,
      "position": _vm.$store.state.rotator.activeType
    },
    on: {
      "breadcrumb-home": _vm.home,
      "breadcrumb-click": _vm.changeElType
    },
    model: {
      value: (_vm.initialized),
      callback: function($$v) {
        _vm.initialized = $$v
      },
      expression: "initialized"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "proxy-holder"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "tag": "div",
      "duration": 300
    }
  }, [_c('ProxyFrame', {
    key: "frame",
    ref: "proxy-iframe",
    staticClass: "proxy-iframe-container",
    class: {
      offset: _vm.$store.state.rotator.activeType < 0
    },
    style: (_vm.frameStyle)
  }), _vm._v(" "), _c('UrlView', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.rotator.activeType < 0),
      expression: "$store.state.rotator.activeType < 0"
    }],
    key: "url",
    on: {
      "submit": _vm.submit
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "panel-toggle"
    }
  }, [(this.$store.state.rotator.activeType == -1 && _vm.instructionState) ? _c('SlideoutContainer', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("GETTING STARTED")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "instruction-video"
  }, [_c('iframe', {
    attrs: {
      "width": "853",
      "height": "480",
      "src": "https://www.youtube.com/embed/VwrSHyMUO0U?rel=0&showinfo=0",
      "frameborder": "0",
      "allow": "autoplay; encrypted-media",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "form-button__default form-button__largetext",
    on: {
      "click": function($event) {
        _vm.instructionState = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(this.$store.state.rotator.activeType >= 0 ? 'Close Instructions' : 'Ready to Integrate') + "\n          ")])])])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "fade"
    }
  }, [(this.$store.state.rotator.activeType == 5) ? _c('SlideoutContainer', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("SDK INTEGRATION")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('Instruction')], 1)]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Getting Started",
      "placement": "bottom"
    }
  }, [_c('div', {
    ref: "instructionState",
    staticClass: "speeddial-holder instruction-dial",
    class: this.$store.state.rotator.activeType == -1 && !_vm.instructionState ? 'shrink' : '',
    on: {
      "click": function($event) {
        _vm.instructionState = true
      }
    }
  }, [_c('div', {
    staticClass: "speeddial-btn speeddial-btn__parent"
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scale",
      "tag": "div"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.rotator.activeType >= 0 && this.$store.state.rotator.activeType <= 4),
      expression: "this.$store.state.rotator.activeType >= 0 && this.$store.state.rotator.activeType <= 4"
    }],
    staticClass: "button-collection"
  }, [_c('SpeedDialMenu', {
    attrs: {
      "delay": 45
    }
  }, [_c('SpeedDialItem', {
    on: {
      "click": function($event) {
        _vm.changeWidth('360px')
      }
    }
  }, [_c('div', {
    staticClass: "height-fix",
    domProps: {
      "innerHTML": _vm._s(_vm.SVGGraphics.default.mobile)
    }
  })]), _vm._v(" "), _c('SpeedDialItem', {
    attrs: {
      "initial": true
    },
    on: {
      "click": function($event) {
        _vm.changeWidth('100%')
      }
    }
  }, [_c('div', {
    staticClass: "height-fix",
    domProps: {
      "innerHTML": _vm._s(_vm.SVGGraphics.default.desktop)
    }
  })])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Next Step",
      "placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "speeddial-holder",
    on: {
      "click": _vm.nextEl
    }
  }, [_c('div', {
    staticClass: "speeddial-btn speeddial-btn__parent"
  }, [_c('div', {
    staticClass: "morph-icon"
  }, [_c('div', {
    staticClass: "morph-bar morph-bar__top"
  }), _vm._v(" "), _c('div', {
    staticClass: "morph-bar morph-bar__bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "morph-bar morph-bar__download"
  })])])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e14cde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/radius.vue
// module id = fzS2
// module chunks = 1